import { render, staticRenderFns } from "./WarningBanner.vue?vue&type=template&id=30a94cf2"
import script from "./WarningBanner.vue?vue&type=script&lang=ts"
export * from "./WarningBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports